import React from "react";

const TermsInner = () => {
  return (
    <div className="service-area pd-top-130 pd-bottom-45">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="service-details-wrap" style={{textAlign:"justify"}}>
              <h2>TERMS & CONDITIONS OF CARRIAGE</h2>
              <h6 className="subtitle CorporateInformation">
                Carrier’s Risk or Owner’s Risk
              </h6>
              <ul className="list-inner-wrap">
                <li>
                  If the Transport Operator does not delete one of the two
                  inscriptions on the face of this LORRY RECEIPT, namely
                  CARRIER'S RISK/OWNER'S RISK, this lorry receipt shall be
                  deemed to have been issued at Owner's RISK only.{" "}
                </li>
                <li>
                  Where a Bank has agreed to accept this Lorry Receipt as a
                  consignee/endorsee or holder thereof or in any other capacity
                  for the purpose of giving advances to and/or collection of
                  discounting bills of any its customers whether before or after
                  the entrustment of the goods to the Transport Operator for
                  carriage, the Transport Operator hereby agrees, in
                  consideration of the same, to hold itself liable and shall be
                  deemed to have held it self liable at all material times,
                  directly to the Bank concerned, as if the Bank were a party to
                  the contract herein contained with the right of recourse
                  against the Transport Operator to the extent of the full value
                  of the goods handed over to the Transport Operator for
                  carriage, storage and delivery.
                </li>
                <li>
                  The Transport Operator undertakes to, and shall, deliver the
                  goods in the same order and condition as received subject to
                  any deterioration in the condition of goods resulting from
                  natural causes like effect of temperature, weather conditions,
                  etc. to the Consignee Bank or to its order or its assigns on
                  this Lorry Receipt being surrendered duly discharged by the
                  Bank or duly discharged by the holder of this Lorry Receipt
                  along with a letter from such Bank authorising delivery of the
                  goods. Only the Bank and the holder of the receipt entitled to
                  delivery as aforesaid shall have right of recourse against the
                  Transport Operator for all claims arising thereon.
                </li>
                <li>
                  The Transport Operator shall have the right to entrust the
                  goods to any other lorry or service for transport, in the
                  event of the goods being so entrusted by the Transport
                  Operator to another Carrier, the other carrier shall as
                  between the consignor, the Consignee Bank and the Transport
                  Operator be deemed to be the Transport Operator's agent so
                  that the Transport Operator shall, not with standing the
                  delivery of the goods to the other carrier, continue to be
                  responsible for the safety of the goods and for their due
                  delivery at the destination.
                </li>
                <li>
                  The Consignor shall be primarily liable to pay the transport
                  charges and all other incidental charges, if any, at the Head
                  Office of the Transport Operator or at any other agreed place.{" "}
                </li>
                <li>
                  The Transport Operator shall have the right to dispose of
                  perishably lying undelivered after 48 hours of arrival,
                  without any notice.
                </li>
                <li>
                  The Transport Operator shall have the right to dispose of
                  other goods after 30 days of arrival, after giving to the
                  Consignor, the Consignee Bank and the holder interested at
                  least a minimum of 15 days notice of such disposal of goods.
                </li>
                <li>
                  In cases falling under Clause 6 or 7 above, the Bank or
                  claimant with Bank's authority shall be entitled to the
                  proceeds, less freight and demurrage, and the Transport
                  Operator shall render full accounts to it/him immediately
                  after sale.
                </li>
                <li>
                  The Consignee Bank accepting Lorry Receipt under clause 2
                  above will not be liable for payment of any charges arising
                  out of any lien of the Transport Operator against the
                  consignor or the buyer, where under the IBA Scheme for
                  Recommending Transport Operator to Member Banks, it becomes
                  necessary for any Bank to obtain delivery of the consignment
                  from the Transport Operator (because the buyer does not retire
                  the documents or because of any other reason), the Transport
                  Operator shall deliver the goods unconditionally to the Bank
                  on payment of the normal freight and storage charges only in
                  connection with the consignment in ques- tion, without
                  claiming any lien on the goods in respect of any monies due by
                  the consignor or the consignee to the Transport Operator on
                  any account whatsoever.
                </li>
                <li>
                  Notwithstanding any statement made in this Lorry Receipt or
                  any circumstances surrounding the issue of this Lorry Receipt,
                  the Transport Operator shall at all times observe its
                  obligation to the Consignee Bank named in this Lorry Receipt
                  and shall be responsible for safe and due delivery, and for
                  any loss or damage to the goods or Consignment, that arises as
                  a result of negligence, default, failure to lake reasonable
                  precautions, malafides or criminal of fraudulent action of the
                  Transport Operator or any of its Managers, Agents, Employees,
                  Partners, Directors, Business associates, branches etc.
                </li>
                <li>
                  The Transport Operator shall preserve Lorry Receipts and other
                  records at least for a period of three years. Wherever, fraud
                  is detected or action is initiated, then the record has to be
                  preserved till the matter is settled.
                </li>
                <li>
                  The Consignor is responsible for all consequences of any
                  incorrect or false declaration.
                </li>
                <li>
                  Where the goods have been lost, destroyed damaged or have
                  deteriorated, the compensation payable by the Transport
                  Operator shall be governed by the Carriage by Road Act-2007
                  (India).
                </li>
                <li>
                  Nature, contents, condition and value of the consignments as
                  declared by the Consignor to the Transport Operator are
                  specified in this Lorry Receipt. The Transport Operator
                  carries the goods as packed at Carrier's Risk. a special rate
                  of Rs...................... for every hundred rupees of value
                  declared by the Consignor having been charged and paid.
                </li>
                <li>
                  The Transport Company won't be responsible for any penalty
                  arising due to..<br/>
                   1. Wrong declaration in invoice/E-way Bill<br/>
                   2. Non lifting of material within E-Way bill validity
                </li>
              </ul>
              <div>
              <h4 style={{marginTop:"20px",marginBottom:"20px"}}>Declaration by Consignor</h4>
                <div className='row'>
                      <div className='col-xl-12 col-lg-12 col-md-6'>
                        <p>I here by solemnly declare to the Transport Operator and all concerned that the particulars of the consignment mentioned in the Lorry Receipt are true and correct and correspond to the entries and descriptions in our books of accounts and other related documents in our possession or control.</p>
                        <p>Signature of Consignor ………………………………………….</p>
                      </div>
                    </div>
              </div>
              <div>
              <h4
                    className="reg-offices"
                    style={{ marginTop: "20px", marginBottom: "20px" }}
                  >
                    Main Offices:
                  </h4>
                  <div className="row">
                    <div className="col-xl-6 col-lg-12 col-md-6">
                    <h6>Name</h6>
                        <div >
                          <ul className=" mb-mb-0 mb-3 mb-lg-3 mb-xl-0" style={{listStyleType:"none",padding:"0px"}}>
                            <li>Ahmedabad</li>
                            <li>Mumbai</li>
                            <li>Pune</li>
                            <li>Bangalore</li>
                            <li>Chennai</li>
                            <li>Hyderabad</li>
                            <li>Delhi</li>
                            <li>Chandigarh</li>
                            <li>Patna</li>
                            <li>Guwahati</li>
                            <li>Kolkata</li>
                            <li>Siliguri</li>
                            <li>Cuttack</li>
                            <li>Muzaffarpur</li>
                            <li>Bhagalpur</li>
                          </ul>
                        </div>
                    
                    </div>

                    <div className="col-xl-6 col-lg-12 col-md-6">
                      <h6>Phone</h6>
                      
                        <div>
                          <ul className="mb-mb-0 mb-3 mb-lg-3 mb-xl-0" style={{listStyleType:"none",padding:"0px"}}>
                          <li>079-25736659-60</li>
                            <li>022-66317261-62</li>
                            <li>020-27659224</li>
                            <li>080-22485725-27</li>
                            <li>044-26490426</li>
                            <li>040-24023824-26</li>
                            <li>011-23517516-19</li>
                            <li>0172-2653955</li>
                            <li>9135005185-86</li>
                            <li>0361-2542978, 2336754, 7419702690</li>
                            <li>033 2235 4330/4349</li>
                            <li>0353-2432 207</li>
                            <li>0671-2311 648/884</li>
                            <li>0621-2246044</li>
                            <li>0641-2421 270</li>
                          </ul>
                        </div>
                    
                    </div>
                  </div>

                  </div>
              </div>
             
            </div>
          </div>
        </div>
      </div>
  );
};

export default TermsInner;
